import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'
import { RegenerateButton } from './RegenerateButton'
import { UploadButton } from './UploadButton'

interface MissingLogoProps {
  onUpload: (file: File) => void
  onRegenerate?: () => void
  isUploading: boolean
}

export const MissingLogo = ({ onUpload, isUploading, onRegenerate }: MissingLogoProps) => {
  if (isUploading) {
    return (
      <div>
        <LoadingEllipses />
      </div>
    )
  }

  return (
    <>
      <UploadButton onUpload={onUpload} />
      {onRegenerate && <RegenerateButton onRegenerate={onRegenerate} />}
    </>
  )
}
